/* What an opponent profile looks like on screen.

   The colour is stored as one of eight names, and the hues themselves are chosen once in
   CSS — see the `--profile-*` custom properties in styles/tokens.css — so that every place
   that paints a profile paints the same eight and a theme can move all of them at once. */

import { opponentOf, type Opponent } from "@preflop/core";

/** The picker's first opponent button: the chart itself, against nobody in particular. Not a
    profile id — no id holds a capital or a space — so it can never be one. */
export const BASIC = "Basic Strategy";

export const BASIC_HELP = "The chart as it stands, against an opponent you know nothing about.";

/** The colour a profile wears, as CSS. Empty for a profile the collection does not hold: a
    chart naming one still says which, it just has no colour to say it in. */
export const profileColor = (list: readonly Opponent[], id: string | null | undefined): string => {
  const held = opponentOf(list, id);
  return held ? `var(--profile-${held.color})` : "";
};
